module.exports = __webpack_public_path__ + "img/zones-de-construction.9f10f8cc.jpg";